// The single way a story text reaches the player — CCT-389.
//
// ⚠️ ONE COMPONENT, OR THE RULE HOLDS ON THREE SCREENS OUT OF FOUR. Chats, cards, user stories
// and scenes all display text written by an author or produced by the model; a rule applied
// screen by screen is a rule the next screen will not have.
import React from 'react';
import { Text, TextProps } from 'react-native';

import { segments } from '../utils/richText';

interface Props extends TextProps {
  /** The AUTHORED or GENERATED text. `null`/`undefined` render an empty string, never "null". */
  value?: string | null;
}

/**
 * Renders `**bold**` as bold, drops the em dash, and keeps everything else untouched.
 *
 * ⚠️ NESTED `Text`, NOT A LIST OF VIEWS. Only nested text flows inside a paragraph: wrapping the
 * runs in views would break every line at each emphasis.
 */
export default function RichText({ value, ...rest }: Props) {
  const parts = segments(String(value ?? ''));
  return (
    <Text {...rest}>
      {parts.map((s, i) => (
        s.gras
          ? <Text key={i} style={{ fontWeight: '700' }}>{s.text}</Text>
          : <Text key={i}>{s.text}</Text>
      ))}
    </Text>
  );
}
